module.exports = __webpack_public_path__ + "img/py_home_banner.233e4709.png";